import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/Dashboard.css";
import TableComponent from "../components/TableComponent/TableComponent";
import { handleGetAllAdmin } from "../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { ICONS } from "../constants/constants";
import { Link } from "react-router-dom";
import {
  handleGetTenantAdminsData,
  handleGetTenantData,
} from "../store/actions/tenantsActions";
import jsPDF from "jspdf";
import "jspdf-autotable";
// import EditFarmerModal from "../components/Modals/EditFarmerModal";
import Loader from "../assets/images/loader.gif";
const Admins = () => {
  const dispatch = useDispatch();
  //const { adminList } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.user);

  const { tenantData, tenantAdminsData, isLoading } = useSelector((state) => state.tenants);
  //const { tenantAdminsData } = useSelector((state) => state.tenants);
  // const usersList = tenantData?.data?.tenant?.users;
  const tenantName = tenantData?.data?.tenant?.name;

 // const adminList = usersList?.filter((user) => user.role === "admin");


  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin

  useEffect(() => {
    // Fetch tenant data if the user is a superadmin and their ID is available
    if (tenantId) {
      dispatch(handleGetTenantAdminsData(tenantId));
      dispatch(handleGetTenantData(tenantId));
    }
  }, [dispatch, tenantId]);

  // const [data, setData] = useState([]); // Added state for data

  // useEffect(() => {
  //   handleGetAllAdmin(dispatch);
  // }, [dispatch]);

  // useEffect(() => {
  //   if (adminList?.data?.admins) {
  //     const formattedData = adminList.data.admins.map((admin) => ({
  //       Tenant: admin.tenant?.name || "N/A",
  //       Name: admin?.name || "N/A",
  //       Email: admin?.email || "N/A",
  //       Company:
  //         admin.companies && admin.companies.length > 0
  //           ? admin.companies[0].name
  //           : "N/A",
  //       Address: admin?.address || "N/A",
  //       CNIC: admin?.cnic || "N/A",
  //       Approved: admin?.account_status === "Approved",
  //     }));
  //     setData(formattedData);
  //   }
  // }, [adminList]);


  // const [showEditModal, setShowEditModal] = useState(false); // State to control edit modal visibility
  // // Handle edit icon click to show edit modal
  // const handleEditClick = (admin) => {
  //   setShowEditModal(true); // Show the edit modal
  // };
  // PDF Downloader
  const handleDownloadPDF = (admin) => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Admin Details", 14, 20);

    // Farmer Data
    // const farmArea = supplier.farmDetails?.reduce(
    //   (sum, farm) => sum + (parseFloat(farm.farm_area) || 0),
    //   0
    // );

    const tableColumn = ["Field", "Details"];
    const tableRows = [
      ["ID", admin?.id],
      ["Tenant", tenantName],
      ["Name", admin?.name],
      ["Email", admin?.email],
      ["Company", admin?.companies[0]?.name || "N/A"],
      // ["ShariahBudget", admin?.shiriahBudgets[0]?.budgetPerAcre || 0],
      //Company: admin?.companies[0]?.name ? admin?.companies[0]?.name : "N/A",
      ["CNIC", admin?.cnic || "N/A"],
      ["Address", admin?.address || "N/A"],
      // ["Farm Area", farmArea ? `${farmArea} acres` : "N/A"],
      ["Status", admin?.account_status || "Pending"],
    ];

    // AutoTable for formatting
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [0, 128, 0], // Green header background
        textColor: [255, 255, 255], // White text color
        fontStyle: "bold",
      },
    });

    // Save PDF
    doc.save(`Admin_${admin?.id}.pdf`);
  };
console.log("tenantAdminsData", tenantAdminsData?.data?.admins);
  // Make sure you map over the correct data structure
  const data = tenantAdminsData?.data?.admins?.map((admin) => ({
    Tenant: tenantName || "N/A",
    Name: admin?.name,
    Email: admin?.email,
    Company: admin?.companies[0]?.name ? admin?.companies[0]?.name : "N/A",
    Address: admin?.address || "N/A",
    CNIC: admin?.cnic || "N/A",
    Status: admin?.account_status || "N/A",
    BudgetPerAcre: admin?.shiriahBudgets[0]?.budgetPerAcre || 0,
    Actions:
      admin?.account_status === "Approved" ? (
        <>
          <Link
            to={`/adminuser/${admin.id}`}
            state={{ admin }} // Correct way to send state in React Router v6
            rel="noopener noreferrer"
          >
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          {/* <img
            src={ICONS.editIcon}
            alt="Edit"
            className="cross-icon"
            onClick={() => handleEditClick(admin)}
          /> */}
          <img
            src={ICONS.downloadIcon}
            alt="Download"
            className="cross-icon"
            onClick={() => handleDownloadPDF(admin)} // Pass specific farmer
          />
        </>
      ) : (
        <>
          <img src={ICONS.tickIcon} alt="Alert" className="alert-icon" />
          <img
            src={ICONS.crossIcon}
            alt="Pending"
            className="pending-icon ms-2"
          />
        </>
      ),
  }));


  const tableTitle = "Admins";

  const columns = [
    "Tenant",
    "Name",
    "Email",
    "Company",
    "Address",
    "CNIC",
    "Status",
    "BudgetPerAcre",
    "Actions",
  ];
  // const data = [
  //   {
  //     Name: "Admin1",
  //     Email: "admin1@example.com",
  //     Company: "Baghe",
  //     Address: "Islamabad",
  //     Mobile: "+923001234567",
  //     CNIC: "3100-1234567-8",
  //     Approved: true,
  //   },
  //   {
  //     Name: "Admin2",
  //     Email: "admin2@example.com",
  //     Company: "Baghe2",
  //     Address: "Karachi",
  //     Mobile: "+923001234568",
  //     CNIC: "3100-1234568-9",
  //     Password: "Password",
  //     Approved: true,
  //   },
  //   {
  //     Name: "Admin3",
  //     Email: "admin3@example.com",
  //     Company: "Baghe3",
  //     Address: "Lahore",
  //     Mobile: "+923001234569",
  //     CNIC: "3100-1234569-1",
  //     Password: "Password",
  //     Approved: false,
  //   },
  //   {
  //     Name: "Admin4",
  //     Email: "admin4@example.com",
  //     Company: "Baghe4",
  //     Address: "Rawalpindi",
  //     Mobile: "+923001234570",
  //     CNIC: "3100-1234570-3",
  //     Password: "Password",
  //     Approved: true,
  //   },
  // ];

  // const handleEdit = (row) => {
  // };

  // const handleDelete = (row) => {
  // };

  // const handleDownload = (row) => {
  // };

  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const showFilter = false; // Change to false to hide filter
  const showTabs = false; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;
  const showCount = true;
  const showAddNewAdmin = true;
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }
  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          {!(tenantAdminsData?.data?.admins && tenantAdminsData.data.admins.length > 0) ? (
            <div className="text-center py-5">No admin available</div>
          ) : (
            <TableComponent
              columns={columns}
              data={data}
              title={tableTitle}
              showSearchBar={showSearchBar}
              showFilter={showFilter}
              showTabs={showTabs}
              showColors={showColors}
              showCount={showCount}
              onEdit={false}
              onDelete={false}
              onDownload={false}
              showAddNewAdmin={showAddNewAdmin}
              searchplaceholder="Search by Admin's Name, CNIC, Phone number"
              customClass=""
            />
          )}
        </Col>
      </Row>
      {/* <EditFarmerModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        user={user}
        userType={user?.userdatarole}
      /> */}
    </Container>
  );
};

export default Admins;
